// The Terms of Service version: its "last updated" date. Keep TERMS_VERSION the same as the
// server's models.TermsVersion (checkout records the version a shop agreed to), and bump both —
// and the /terms page's `modified` — when the terms change.
export const TERMS_VERSION = '2026-10-17';
export const TERMS_UPDATED = 'October 17, 2026';
